<app-admin-custom-control [label]="label" [centerLabel]="centerLabel" [labelCols]="labelCols" [dividerKind]="dividerKind" [uniqueId]="uniqueId">
  <div class="form-check noselect">
    <input type="checkbox" class="form-check-input" [id]="'label'+uniqueId" [(ngModel)]="_model" [disabled]="disabled" (ngModelChange)="changeModel($event)" (change)="changedModel()">
    <label class="form-check-label" [for]="'label'+uniqueId">{{extraLabel}}</label>
  </div>
</app-admin-custom-control>